import type { TransactionDetail } from '../core/api/http-methods/get-user-transactions';
import { apiClient } from './client';

interface TransactionDetailSuccessResponse {
  success: true;
  status: number;
  data: TransactionDetail;
}

export const getTransactionDetail = async (
  id: string
): Promise<TransactionDetail> => {
  const response = await apiClient.get<TransactionDetailSuccessResponse>(
    `/transactions/${id}`
  );
  return response.data?.data;
};
